module.exports = __webpack_public_path__ + "img/light-fog.7933bafb.svg";